<div class="scroll-title" *ngIf="isShow">如果内容显示不全，请滑动页面</div>




// WEBPACK FOOTER //
// ./src/app/scroll-title/component.scroll-title.html